module.exports = "<a [href]=\"url\" class=\"btn btn-primary\">\n  <i [ngClass]=\"icon\"></i>\n  <span>{{ title }}</span>\n</a>"